
import { Dispatch, SetStateAction } from 'react';

import Close from '@mui/icons-material/Close';
import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import { SearchIcon } from '../../iconRef/recipePageIcons';
import styles from "./searchRecipe.module.css";

interface SearchRecipeProps {
    recipeImg: string;
    setRecipeName: Dispatch<SetStateAction<string>>;
    setRecipeImg: Dispatch<SetStateAction<string>>;
    setLoaderDisplay: Dispatch<SetStateAction<boolean>>;
    typeHandler: (queryString: string) => void;
}
type CombinedProps = TextFieldProps & SearchRecipeProps;

const SearchRecipe = (params: CombinedProps) => {
    const { recipeImg, setRecipeName, setRecipeImg, setLoaderDisplay, typeHandler } = params;
    const startAdornment = () =>
    (<InputAdornment position="start">
        {recipeImg !== "" ? (
            <Grid item>
                <ButtonBase sx={{ width: 40, height: 40 }}>
                    <img alt='' height='100%' src={recipeImg}
                        width='100%' />
                </ButtonBase>
            </Grid>
        ) : (
            <SearchIcon />
        )}
    </InputAdornment>)

    const endAdornment = () => (
        <InputAdornment position="end">
            {params.inputProps && params.inputProps.value && (
                <IconButton className={styles.close_icon} onClick={() => {
                    setRecipeName("");
                    setRecipeImg("");
                    setLoaderDisplay(false);
                }}>
                    <Close sx={{ color: '#878787' }} />
                </IconButton>
            )}
        </InputAdornment>
    )

    return (
        <TextField
            {...params}
            color='secondary'
            InputProps={{
                ...params.InputProps,
                startAdornment: startAdornment(),
                endAdornment: endAdornment(),
            }}
            onChange={(e) => typeHandler(e.target.value)}
            placeholder='  Search for a recipe'
        />
    );
};

export default SearchRecipe;
